import FileOpenOutlinedIcon from "@mui/icons-material/FileOpenOutlined";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { Box, CircularProgress } from "@mui/material";
import { ReactElement, useEffect, useState } from "react";

import { Asset } from "../../generated/gql/graphql";
import {
  getDirectusAssetsPath,
  useDirectus,
} from "../../providers/DirectusProvider";
import { AssetType } from "../../types/assets";

type Props = {
  asset: Asset;
};

export default function AssetPreview(props: Props): ReactElement {
  const { asset } = props;

  const [type, setType] = useState<AssetType>();
  const [isLoading, setIsLoading] = useState(true);

  const { directus } = useDirectus();

  async function loadAssetType(): Promise<void> {
    if (!asset.image) {
      setIsLoading(false);
      return;
    }

    const result = await directus?.files.readOne(asset.image);
    if (!result) {
      return;
    }

    setType(result.type as AssetType);
    setIsLoading(false);
  }

  useEffect(() => {
    loadAssetType();
  }, [asset]);

  function toggleModal(): void {
    throw new Error("Not implemented yet");
  }

  if (isLoading) {
    return (
      <Box className="flex w-full justify-center">
        <CircularProgress />
      </Box>
    );
  }

  switch (type) {
    case AssetType.pdf:
      return (
        <PictureAsPdfIcon
          onClick={toggleModal}
          style={{ color: "#DD2127" }}
          className="text-[300px] cursor-zoom-in"
        />
      );
    case AssetType.psd:
      return (
        <FileOpenOutlinedIcon
          style={{ color: "#DD2127" }}
          className="text-[300px]"
        />
      );
    case AssetType.mp4:
      return (
        <video
          className="w-full"
          controls
          src={`${getDirectusAssetsPath(directus)}/${asset?.image}`}
        />
      );
    case AssetType.webp:
    case AssetType.png:
    case AssetType.jpg:
    case AssetType.jpeg:
    case AssetType.tiff:
      return (
        <img
          onClick={toggleModal}
          className="inline-block w-full h-full max-w-[100%] max-h-[700px] object-contain cursor-zoom-in"
          src={`${getDirectusAssetsPath(directus)}/${
            asset?.image
          }?width=700&format=png`}
          alt="preview image"
        />
      );
    default:
      return <img src="/assets/default-fallback.svg" alt={asset.name || ""} />;
  }
}
